import { AfterViewInit, Directive, ElementRef, inject } from '@angular/core';

/** Focuses the host element once it is rendered — e.g. the search input of an opened popup. */
@Directive({ selector: '[recrewtAutofocus]' })
export class AutofocusDirective implements AfterViewInit {
  private el = inject(ElementRef<HTMLElement>);

  ngAfterViewInit(): void {
    this.el.nativeElement.focus();
  }
}
